module.exports = {
  IDLE: 0,
  SENT: 1,
  RECEIVED: 2,
  NOT_SENT: 3,
  NOT_RECEIVED: 4,
  WAITING: 5
}